"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styles = require("@material-ui/core/styles");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var palette = _ref.palette;
  return {
    subtitle1: {
      fontWeight: 'bold',
      marginBottom: '15px',
      color: palette.text.secondary
    }
  };
});
var _default = useStyles;
exports["default"] = _default;